/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var xyzSource = _interopDefault(require('../mixin/xyz-source'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var minilo = require('../util/minilo');

/**
 * @module osm-source/source
 */
var OSMSource = __ol__.source.OSM;


var OSM_ATTRIBUTIONS = '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.';
var OSM_URL_TEMPLATE = 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png';
var OSM_MAX_ZOOM = 19;

var props = {
  attributions: {
    type: [String, Array],
    default: OSM_ATTRIBUTIONS
  },
  maxZoom: {
    type: Number,
    default: OSM_MAX_ZOOM
  },
  url: {
    type: String,
    default: OSM_URL_TEMPLATE
  }
};

var methods = {
  createSource: function createSource() {
    // always EPSG:3857, size: 256x256, format png
    return new OSMSource({
      url: this.urlTmpl,
      attributions: this.attributions,
      crossOrigin: this.crossOrigin,
      maxZoom: this.maxZoom,
      cacheSize: this.cacheSize,
      opaque: this.opaque,
      reprojectionErrorThreshold: this.reprojectionErrorThreshold,
      wrapX: this.wrapX,
      transition: this.transition
    });
  }
};

var Source = {
  name: 'vl-source-osm',
  mixins: [xyzSource],
  props: props,
  methods: methods
};

/**
 * @alias module:osm-source
 */
var index = {
  /**
   * @alias module:osm-source/source
   */
  Source: Source,
  /**
   * @param {Vue} Vue
   * @param {VueLayersOptions} [options]
   */
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Source, options);

    Vue.component(Source.name, Source);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/osm-source/index.js
// module id = 1478
// module chunks = 1